import type { FaireProductEntity } from "../../entity_types/product";

export const p_by43dx7nrt: FaireProductEntity = {
  token: "p_by43dx7nrt",
  type: "product",
  name: "Malachite elephant carving H377 beautiful pattern",
  brandToken: "b_yrt8x5m6m6",
  brandName: "The 7 Directions",
  imageUrl:
    "https://cdn.faire.com/fastly/e804d81fe36dd3e0ae10515fdec8adeb8d9fde9559b2282714572267db71c7e1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bb8167ff333d9f98f4f599f0d6164ac948558204cd09e30ef609ed579cb5abec.jpeg",
    "https://cdn.faire.com/fastly/55f23e784fa51d27254e3ffa633699a77a11e97209157b95bef8b1779cb478f7.jpeg",
    "https://cdn.faire.com/fastly/f2f0f80d1dedc039bd8f176a095a7fc3a1048d4b48bbe739e547dd1da7925750.jpeg",
    "https://cdn.faire.com/fastly/998c994cc3c1bd286d71c6ea1490f9f5737d1c16a8d897931ce31387bcce6856.jpeg",
    "https://cdn.faire.com/fastly/34a32d3897f9c46486beb396c206fbe33c81a260a0c9d28986289c6287abeab4.jpeg",
    "https://cdn.faire.com/fastly/d2efd2a0930afd8d35a8674408143e2a5e6d0c3f2e9baa534b0c52e137e5c159.jpeg",
    "https://cdn.faire.com/fastly/a35b9eac202fea09c4d5134cc643f34aa490a18f1a284730b27f9dc54d3a0806.jpeg",
  ],
  priceDollars: 54.04,
  description:
    "Malachite elephant carving H377 beautiful pattern\n\nIt comes with one crystal info card\n\nThis is the exact set you will receive\n\nMalachite elephant carving H377 beautiful pattern\n",
  tags: [],
  msrpDollars: 108.08,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:16.009Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
